import React, { useState , useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { v4 as uuidv4 } from "uuid";
import { useHistory } from 'react-router-dom';
import {
  Col,
  Container,
  Row,
  Progress,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Card, CardBody, CardTitle,
} from "reactstrap";
import RechartsPieChart from "../uielements/charts/components/RechartsPieChart";
import Widget from "../../components/Widget/Widget";
import { FcAlarmClock , FcDocument , FcApproval ,FcExpired, FcCancel,FcCalendar , FcBriefcase ,FcPaid  } from "react-icons/fc";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { css } from "@emotion/react";
import { ClockLoader
} from "react-spinners";
import "./Dashboard.css";
import TaskMonthlyChat from "../../components/chats/ApexChatPTask";
import TaskWeeklyChat from "../../components/chats/ApexPWeekly";
import StaffMonthlyTask from "../../components/chats/ApexChartPStaffM";
import CustomerTask from "../../components/chats/ApexPCustomer";
import BaseAPI from "../../api/apiurl";




const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [planned, setPlanned] = useState(null);
  const [inprogress, setInprogress] = useState(null);
  const [Completed, setCompleted] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);

  const Dashboardcount = () =>{
   
    const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');

    if (company_id && customer_id) {
    
      const apiUrl = `${BaseAPI}projectdash?company_id=${company_id}&customer_id=${customer_id}`;

      // Make an HTTP GET request using fetch
      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error('Failed to fetch data');
          }
        })
        .then((data) => {

          setDashboardData(data);
    
          setPlanned(data.data[0].Planned);
          setInprogress(data.data[0].InProgress);
          setCompleted(data.data[0].Completed);
        })
        .catch((error) => {
          console.log (error);
        });
    } else {
      console.log ('company_id and customer_id not found in local storage');
    }
  }

useEffect(() => {
  
  const loadingTimeout = setTimeout(() => {
    setIsLoading(false);
    // NotificationManager.success('Login successful!', 'Success');
    Dashboardcount();
 },1000);

 return () => clearTimeout(loadingTimeout); 
}, []);

  return (
    <div>
    {isLoading ? (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <ClockLoader
 color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
      </div>
    ) : (
<div className="header bg-gradient-info pb-8 pt-md-8">
 <br/>
        <Container fluid>
          <div className="header-body">
            <Row className="no-gutters align-items-center">
              <Col lg="4" xl="4">
                <Card className="card-stats">
                  <CardBody>
                    <Row className="no-gutters">
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px' }}
                          className="text-muted mb-0"
                        >
                          Planned
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                        {planned !== null ? planned : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                      <div className="zoom-in-effect">
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ProjectPlanned"}>
                        <FcCalendar style={{ fontSize: 49 }} />
                        </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="4">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px' }}
                          className=" text-muted mb-0"
                        >
                          In-Progress
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                        {inprogress !== null ? inprogress : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect">
              
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ProjectInProgress"}>
                    <FcDocument style={{ fontSize: 49 }} />
                        </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="4">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px' }}
                          className=" text-muted mb-0"
                        >
                          Completed
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                        {Completed !== null ? Completed : '0'}
                        </span>
                      </div>
                      <Col className="col-auto" style={{height: '20px'}}>
                        <div className="zoom-in-effect">
                       
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ProjectCompleted"}>
                    <FcApproval style={{ fontSize: 49 }} />
                        </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              {/* <Col lg="4" xl="2">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '12px' }}
                          className=" text-muted mb-0"
                        >
                          Cancelled
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                          0
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect">
                     
                      <a href={process.env.PUBLIC_URL + "#/timeinlive/ProjectCancel"}>
                      <FcCancel style={{ fontSize: 30  }} />
                        </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <br></br> <br></br>
              <Col lg="4" xl="2">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '12px' }}
                          className="text-muted mb-0"
                        >
                          Awaiting
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                          0
                        </span>
                      </div>
                      <Col className="col-auto">
                      <div className="zoom-in-effect">
                    
                      <a href={process.env.PUBLIC_URL + "#/timeinlive/ProjectAwaiting"}>
                    <FcAlarmClock style={{   fontSize: 30 }} />
                        </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="2">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '12px' }} 
                          className="text-muted mb-0"
                        >
                          In-Audit
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                          0
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect">
                       
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ProjectTaskPlanned"}>
                        <FcExpired style={{ fontSize: 30 }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col> */}
              {/* <Col lg="4" xl="2">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '12px' }} 
                          className="text-muted mb-0"
                        >
                          Completed
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                          0
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div  className="zoom-in-effect">
                       
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/projectTaskCompleted"}>
                    <FcPaid style={{ fontSize: 29 }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              
              </Col> */}
            </Row>
          </div>
          &nbsp; &nbsp; &nbsp;
          <div className="header-body">
            <Row>
              
        <Col className="pl-grid-col pr-grid-col" xs={6} lg={6}>
          <Row className="gutter mb-4 pl-grid-row pr-grid-row">
            <Col xs={12} xl={12}>
              <Widget className="widget-p-md">
                <div className="headline-2 mb-3" style={{ textAlign :"center"}}>Project by Status</div>
                {/* <TaskMonthlyChat /> */}
                <TaskWeeklyChat />
              </Widget>
            </Col>
          </Row>
          <Row className="gutter mb-4 pl-grid-row pr-grid-row">
            <Col xs={12} xl={12}>
              <Widget className="widget-p-md" style={{ height: "450px", overflowY: "auto" , overflowX: "auto" }}>
                <div className="headline-2 mb-3" style={{ textAlign :"center"}}>Task Per Project</div>
                <CustomerTask />
              </Widget>
            </Col>
          </Row>
        </Col>

        <Col className="pl-grid-col pr-grid-col" xs={6} lg={6}>
        <Row className="gutter mb-4 pl-grid-row pr-grid-row">
            <Col xs={12} xl={12}>
              <Widget className="widget-p-md">
                <div className="headline-2 mb-3" style={{ textAlign :"center"}}>Tasks by Severity</div>
                <StaffMonthlyTask />
              </Widget>
            </Col>
          </Row>
          <Row className="gutter mb-4 pl-grid-row pr-grid-row">
            <Col xs={12} xl={12}>
              <Widget className="widget-p-md">
                <div className="headline-2 mb-3" style={{ textAlign :"center"}}>Project Completion Rate</div>
                {/* <TaskWeeklyChat /> */}
                <TaskMonthlyChat />
              </Widget>
            </Col>
          </Row>
        </Col>
            </Row>
          </div>
        </Container>
        <NotificationContainer />
      </div>
        )}
 </div>
  )
}

const spinnerStyle = css`

  margin: 0 auto;
`;

export default Dashboard;
